export default "__VITE_ASSET__DcW35pb5__"